import { FaHouseDamage, FaProjectDiagram } from 'react-icons/fa'
import { MdOutlineElectricMeter } from 'react-icons/md'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                active: ['/admin/projects'],
                url: '/admin/projects',
                text: 'Projects',
                icon: <FaProjectDiagram />,
            },
            {
                active: ['/admin/transformers'],
                url: '/admin/transformers',
                text: 'Transformers',
                icon: <FaHouseDamage />,
            },
            {
                active: ['/admin/transformer-tests'],
                url: '/admin/transformer-tests',
                text: 'Test Groups',
                icon: <MdOutlineElectricMeter />,
            },
        ],
    },
]

export default appRoutes
